module.exports = __webpack_public_path__ + "static/dm-video-image-b4bba98c055037da531e35dc31f102c6.png";